"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportError = reportError;
var _Core = _interopRequireDefault(require("../dragon/store/Core"));
var _logger = _interopRequireDefault(require("./logger"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function reportError(message) {
  var state = _Core["default"].getState();

  // skip if errorUrl is not configured
  if (!state.config.errorUrl) return;
  console.dir(message);
  _logger["default"].error("Posting Error: " + message);
  fetch(state.config.errorUrl, {
    method: "POST",
    // or 'PUT'
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      message: message,
      playerId: state.config.playerId,
      traceId: state.config.traceId,
      userAgent: navigator.userAgent,
      gameId: state.config.gameId,
      practice: state.config.practice,
      serverUrl: state.config.serverUrl,
      iid: state.config.iId,
      context: state.config.context,
      locale: state.config.locale
    })
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    // console.log("Success:", data);
  })["catch"](function (error) {
    console.error("Error:" + error);
  });
}
//# sourceMappingURL=errorReporter.js.map